'use-strict';

class StickyAddCart extends Popup {
    constructor() {
      super();
      this.init();
    }
    init() {
        this.getHeightAddToCart();
        const btn_minimal = this.querySelector("minimal-button");
        if (btn_minimal) {
            btn_minimal.addEventListener("click", this.toggle.bind(this), false);
        }
    }
    getHeightAddToCart() {
        const _this = this;
        this.main = document.querySelector(".main-product-section");
        if (!this.main) return;
        const primaryBtn = this.main.querySelector(".product-sticky-show");
        const footer = document.querySelector(".product-sticky-hide");
        if (!primaryBtn) return;
        var isVisible = true;
        window.addEventListener('scroll', function() {
            var buttonRect = primaryBtn.getBoundingClientRect();
            var viewportHeight = window.innerHeight;
            if (footer) {
              var footerRect = footer.getBoundingClientRect();
              if (footerRect.top < window.innerHeight - 100) {
                _this.classList.remove("show-sticky-cart");
                isVisible = true;
              }else{
                if (!isVisible && buttonRect.top < viewportHeight && buttonRect.bottom > 0) {
                  isVisible = true;
                  _this.classList.remove("show-sticky-cart");
                } else if (isVisible && (buttonRect.bottom <= 0)) {
                  isVisible = false;
                  _this.classList.add("show-sticky-cart");
                }
              }
            }else{
              if (!isVisible && buttonRect.top < viewportHeight && buttonRect.bottom > 0) {
                isVisible = true;
                _this.classList.remove("show-sticky-cart");
              } else if (isVisible && (buttonRect.bottom <= 0)) {
                isVisible = false;
                _this.classList.add("show-sticky-cart");
              }
            }
        });
    }
    toggle(e) {
        const target = e.currentTarget;
        target.classList.toggle("opened");
        if (!target) return;
        const parent = target.closest("sticky-buy");
        if (!parent) return;
        const content = parent.querySelector(".expand-content");
        slideAnime({
            target: content,
            animeType: "slideToggle",
        });
    }
}
customElements.define("sticky-buy", StickyAddCart);

class GalleryGrid extends SlideSection {
  constructor() {
      super();
      this.init();
  }
  init() {
    this.onResize();
    setTimeout(() => {
      this.pauseMediaGrid();
      this.playMediaGrid();
    }, 300);

  }
  onResize() {
    const _this = this;
    let windowWidth = window.innerWidth;
    let isMobile = windowWidth <= 767;
    window.addEventListener("resize", function() {
      const newWindowWidth = window.innerWidth;
      const newIsMobile = newWindowWidth <= 767;
      if (newIsMobile !== isMobile) {
        windowWidth = newWindowWidth;
        isMobile = newIsMobile;
        _this.actionResize(isMobile);
        _this.pauseMediaGrid();
        _this.playMediaGrid();
      }
    });
    _this.actionResize(isMobile);

  }
  
  actionResize(isMobile) {
    const content = this.loadContent();
    const sl = document.createElement('div');
    const container = this.querySelector(".gallery-grid-js");
    container.innerHTML = "";
    if (content && container) {
      if (isMobile) {
        sl.classList.add("slide-container");
        container.classList.remove("tablet-2", "mb-1", "grid-cols", "gap-small", "row-as-column-gap");
        sl.innerHTML = content;
        container.appendChild(sl);
        this.initSlide();
        this.destroy();
        this.slider = null;
      } else {
        container.classList.add("tablet-2", "mb-1", "grid-cols", "gap-small", "row-as-column-gap");
        sl.innerHTML = content;
        container.innerHTML = sl.innerHTML;
      }
    }
  }
  loadContent() {
    const content = document.createElement('div');
    if (!this.dataset.variantSelected) {
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
    } else {
      this.querySelector('template').content.querySelectorAll('.slider-image').forEach((image) =>
      {
        const alt = image.dataset.alt;
        if (this.dataset.variantSelected == alt) {
          content.appendChild(image.cloneNode(true));
        }
      });
      if (content.querySelector(".slider-image")) {
        return content.innerHTML;
      } else {
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      }
    }
    if (content.querySelector(".content-items")) {
      return content.querySelector(".content-items").innerHTML;
    }
  }
  pauseMediaGrid() {
    this.querySelectorAll(".slider-model, .slider-image").forEach(e => {
      e.addEventListener("click", () => {
        window.pauseAllMedia(this);
      })
    });
  }
  playMediaGrid() {
    const btnPlay = this.querySelectorAll(".overlay-btn");
    btnPlay.forEach(e => {
      e.addEventListener("click", () => {
        window.pauseAllMedia(this);
        const content = document.createElement('div');
        const itemContainer = e.closest(".slider-external-video") || e.closest(".slider-video");
        if (!itemContainer) return;
        content.appendChild(itemContainer.querySelector('template.video-template').content.firstElementChild.cloneNode(true));

        itemContainer.querySelector(".video-box").classList.remove("d-none");
        itemContainer.querySelector(".video-box").appendChild(content.querySelector('video, iframe'));
        e.remove();
      })
    })
  }
}
customElements.define("gallery-grid", GalleryGrid);

class CollapsibleRow extends HTMLElement {
  constructor() {
      super();
      const _this = this;
      this.querySelector(".detail-parent").addEventListener("click", _this.onToggle.bind(_this), false);
      this.addEventListener('keypress', function(event) {
        if (event.key === 'Enter') {
            _this.onToggle.bind(_this)(event);
        }
    }.bind(_this), false);
  }
  onToggle(e) {
    e.preventDefault();
    const target = this.querySelector(".detail-target");
    const parent = this.querySelector(".detail-parent");
    if (target) {
        slideAnime({
            target: target,
            animeType: "slideToggle",
            parent: parent
        });
    }
  }
}
customElements.define("collapsible-row", CollapsibleRow);

class StockAlert extends Popup {
  constructor() {
      super();
      this.initMessage();
  }
  initMessage() {
      const _this = this;
      let stockalertSuccess = "";
      let stockalertError = "";
      fetch(window.location.origin+"?section_id=form-infor")
      .then(response => response.text())
      .then(text => {
        const html = parser.parseFromString(text, "text/html");
        if (!html) return;
        if (html.querySelector(".stockalert-form-success")) {
          stockalertSuccess = html.querySelector(".stockalert-form-success").innerHTML;
        }
        if (html.querySelector(".stockalert-form-error")) {
          stockalertError = html.querySelector(".stockalert-form-error").innerHTML;
        }
        const urlInfo = window.location.href;
        if (urlInfo.indexOf('contact_posted=true') >= 1) {
          _this.initToastJs(stockalertSuccess);
          const newURL = location.href.split("?")[0];
          window.history.pushState('object', document.title, newURL);
        }
      })
      .catch(e => {
        console.error(e);
      });
      
    }
    initToastJs(content = "") { 
      let myToast = EasyDialogBox.create(null, 'dlg-toast dlg-fade', null, content, null, null, 10, 400);
      myToast.onHide = myToast.destroy;
      myToast.show().hide(3000);
    }
}
customElements.define("stock-alert", StockAlert);

document.addEventListener('DOMContentLoaded', function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];

    var currentProductID = productJson.id;
    var product = {
      id: currentProductID,
    };
    if (JSON.parse(localStorage.getItem('product')) != currentProductID) {
      localStorage.setItem('product', JSON.stringify(product));
    }
    if (storedProducts.length < 25) {
      for (var i = storedProducts.length; i--; ) {
        var curProduct = storedProducts[i];
        if (curProduct.id === product.id) {
          storedProducts.splice(i, 1);
          break;
        }
      }
    }else{
      storedProducts.shift();
      for (var i = storedProducts.length; i--; ) {
        var curProduct = storedProducts[i];
        if (curProduct.id === product.id) {
          storedProducts.splice(i, 1);
          break;
        }
      }
    }
    storedProducts.push(product);
    if (localStorage.getItem(storedProducts)) {
      localStorage.getItem('bl_recently-viewed-products', JSON.stringify(storedProducts));
    } else {
      localStorage.setItem('bl_recently-viewed-products', JSON.stringify(storedProducts));
    }
  }
  const prodData = document.querySelector('[data-product-json]');
  if (prodData != null) {
    var productJson = JSON.parse(prodData.innerHTML);
    var storedProducts = JSON.parse(localStorage.getItem('bl_recently-viewed-products'));
    addProductEntry(productJson, storedProducts);
  }
  var canvasEscFunc = (function () {
    return {
      onEscKeyUp: function () {
        const canvas = document.querySelectorAll(".canvas-main-product");
        if (canvas.length == 0) return;
        canvas.forEach((e) => {
          e.addEventListener("keyup", (event) => {
            if(event.code?.toUpperCase() === 'ESCAPE') {
              if (e.querySelector(".bls__canvas")) {
                e.querySelector(".bls__canvas").classList.remove("active");
                const itemToFocus = e.querySelector(".bls__canvas").dataset.focusItem;
                if (document.querySelector("#"+itemToFocus)) {
                  removeTrapFocus(document.querySelector("#"+itemToFocus));
                }
              }
              rootAction.remove();
            }
          });
        });
      }
    };
  })();
  canvasEscFunc.onEscKeyUp();
});

// === Sara request 2026-05-19: gallery + swatch fixes (v3 — also handle scroll/swipe/arrows) ===
(function () {
  function findPicker(node) {
    return node && node.closest ? node.closest('variant-radios-page, variant-radios-detail, variant-selects-page, variant-selects') : null;
  }

  function applyVariantForMediaId(picker, variants, rawMediaId) {
    if (!rawMediaId) return false;
    var numericId = String(rawMediaId).split('-').pop();
    var variant = variants.find(function (v) {
      return v.featured_media && String(v.featured_media.id) === String(numericId);
    });
    if (!variant) return false;
    var fieldsets = picker.querySelectorAll('fieldset');
    var changed = false;
    ['option1', 'option2', 'option3'].forEach(function (key, i) {
      var value = variant[key];
      if (!value) return;
      var fs = fieldsets[i];
      if (!fs) return;
      var radios = fs.querySelectorAll('input[type="radio"]');
      radios.forEach(function (r) {
        if (r.value === value && !r.checked) { r.checked = true; changed = true; }
      });
    });
    if (changed) picker.dispatchEvent(new Event('change', { bubbles: true }));
    return changed;
  }

  // (1) Click-based bridge — fast path for tapping a photo directly.
  //     Document-level delegation so it survives gallery re-renders.
  function initGalleryClickBridge() {
    if (document.__galleryVariantBridgeBound === true) return;
    document.__galleryVariantBridgeBound = true;

    document.addEventListener('click', function (e) {
      var node = e.target.closest('[data-media-id], .slider-image, .slider-thumbnail');
      if (!node) return;
      if (!node.closest('media-gallery')) return;
      var section = node.closest('section.main__product, section.product__item-js.main__product, section.main-product-section');
      if (!section) return;
      var picker = section.querySelector('variant-radios-page, variant-selects-page, variant-radios-detail:not([id*="quickview"]), variant-selects');
      if (!picker) return;
      var variantsScript = picker.querySelector('script[type="application/json"]');
      if (!variantsScript) return;
      var variants;
      try { variants = JSON.parse(variantsScript.textContent); } catch (err) { return; }

      var mediaId = node.getAttribute('data-media-id') || '';
      if (!mediaId) {
        // Slider thumbnails don't carry data-media-id; fall back to position.
        var positionStr = node.getAttribute('data-position');
        var position = positionStr ? parseInt(positionStr, 10) : null;
        if (position != null && !isNaN(position)) {
          var pv = variants.find(function (v) { return v.featured_image && v.featured_image.position === position; });
          if (pv && pv.featured_media) mediaId = String(pv.featured_media.id);
        }
      }
      if (mediaId) applyVariantForMediaId(picker, variants, mediaId);
    }, false);
  }

  // (1b) Active-slide observer — catches arrow navigation, swipes,
  //      thumbnail-rail clicks, and any other carousel movement.
  function initActiveSlideBridge() {
    if (document.__activeSlideObserverBound === true) return;
    document.__activeSlideObserverBound = true;

    var sections = document.querySelectorAll('section.main__product, section.product__item-js.main__product, section.main-product-section');
    sections.forEach(function (section) {
      var picker = section.querySelector('variant-radios-page, variant-selects-page, variant-radios-detail:not([id*="quickview"]), variant-selects');
      if (!picker) return;

      function getVariants() {
        var s = picker.querySelector('script[type="application/json"]');
        if (!s) return null;
        try { return JSON.parse(s.textContent); } catch (e) { return null; }
      }

      function findGallery() {
        return section.querySelector('media-gallery');
      }

      function getActiveMediaId(gallery) {
        if (!gallery) return null;
        // Prefer the main slider's currently-active slide, ignoring tns clones.
        var active =
          gallery.querySelector('.slide-section-media .slider-image.tns-slide-active:not(.tns-slide-cloned)') ||
          gallery.querySelector('.slider-image.tns-slide-active:not(.tns-slide-cloned)') ||
          gallery.querySelector('.slider-image.is-active') ||
          gallery.querySelector('.slider-image.active');
        return active ? active.getAttribute('data-media-id') : null;
      }

      var lastSeenMediaId = null;
      var debounceTimer = null;

      function checkActiveSlide() {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          var gallery = findGallery();
          if (!gallery) return;
          var mediaId = getActiveMediaId(gallery);
          if (!mediaId || mediaId === lastSeenMediaId) return;
          lastSeenMediaId = mediaId;
          var variants = getVariants();
          if (variants) applyVariantForMediaId(picker, variants, mediaId);
        }, 80);
      }

      var slideObserver = new MutationObserver(checkActiveSlide);
      function attachSlideObservers() {
        var gallery = findGallery();
        if (!gallery) return;
        gallery.querySelectorAll('.slider-image').forEach(function (img) {
          slideObserver.observe(img, { attributes: true, attributeFilter: ['class'] });
        });
      }

      // Re-attach observers whenever the gallery's contents change
      // (e.g. selectVariant()/reloadGallery() replaces innerHTML).
      var structureObserver = new MutationObserver(function () {
        attachSlideObservers();
        lastSeenMediaId = null; // force a re-check on next tick
        checkActiveSlide();
      });
      var galleryContainer = section.querySelector('#product-media-container') || section;
      structureObserver.observe(galleryContainer, { childList: true, subtree: true });

      attachSlideObservers();
      lastSeenMediaId = getActiveMediaId(findGallery());
    });
  }

  // (2) Fix swatch-group-wrapper labels that point to the wrong picker's radios.
  function initSwatchClickReroute() {
    if (document.__swatchRerouteBound === true) return;
    document.__swatchRerouteBound = true;

    document.addEventListener('click', function (e) {
      var label = e.target.closest('label[for]');
      if (!label) return;
      if (!label.closest('.swatch-group-wrapper')) return;
      var picker = findPicker(label);
      if (!picker) return;
      var forId = label.getAttribute('for');
      if (forId) {
        var existing = document.getElementById(forId);
        if (existing && picker.contains(existing)) return;
      }
      var value = label.getAttribute('title') || label.textContent.trim();
      if (!value) return;
      var fieldset = label.closest('fieldset');
      if (!fieldset) return;
      var radios = fieldset.querySelectorAll('input[type="radio"]');
      var correctRadio = null;
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === value) { correctRadio = radios[i]; break; }
      }
      if (!correctRadio) return;
      e.preventDefault();
      e.stopPropagation();
      if (!correctRadio.checked) {
        correctRadio.checked = true;
        correctRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, true);
  }

  // (3) Sync visible swatch labels with the currently-selected radio (for the
  //     1px #C49B37 stroke CSS).
  function syncSwatchSelectedState(picker) {
    if (!picker) return;
    var fieldsets = picker.querySelectorAll('fieldset');
    fieldsets.forEach(function (fs) {
      var checkedRadio = fs.querySelector('input[type="radio"]:checked');
      var checkedValue = checkedRadio ? checkedRadio.value : null;
      var wrapper = fs.querySelector('.swatch-group-wrapper');
      if (!wrapper) return;
      wrapper.querySelectorAll('label').forEach(function (lbl) {
        var lblValue = lbl.getAttribute('title') || lbl.textContent.trim();
        lbl.classList.toggle('is-selected', !!checkedValue && lblValue === checkedValue);
      });
    });
  }

  function initSwatchSelectedSync() {
    if (document.__swatchSyncBound === true) return;
    document.__swatchSyncBound = true;
    document.addEventListener('change', function (e) {
      var picker = findPicker(e.target);
      if (picker) setTimeout(function () { syncSwatchSelectedState(picker); }, 10);
    }, false);
    function runInitialSync() {
      document.querySelectorAll('variant-radios-page, variant-radios-detail, variant-selects-page, variant-selects').forEach(syncSwatchSelectedState);
    }
    runInitialSync();
    setTimeout(runInitialSync, 200);
    setTimeout(runInitialSync, 1000);
  }

  function init() {
    initGalleryClickBridge();
    initActiveSlideBridge();
    initSwatchClickReroute();
    initSwatchSelectedSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();